import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  commentOnPostApi,
  createPost,
  removePostApi,
  toxicApi,
} from "../Api/api";
import { toast } from "react-toastify";
import {
  createPostFail,
  createPostLoad,
  createPostSuccess,
  postLikeLoad,
  postLikeSuccess,
  removePostSuccess,
  removePostload,
  toxicPostLoad,
} from "../slices/community.slice";
import {
  commentPostSuccess,
  encouragementRenderPostListLoad,
} from "../slices/encouragementgroups.slice";
import { toxicError, toxicLoad, toxicSuccess } from "../slices/common.slice";

function* toxicPostSaga(action) {
  try {
    console.log(action, "action");
    const toxicData = {
      apiKey: action.payload.apiKey,
      comment: action.payload.comment,
    };
    const response = yield call(toxicApi, toxicData);
    if (response?.status == 0) {
      const data =
        response.result?.data?.data?.attributeScores?.TOXICITY?.summaryScore
          ?.value *
          100 >
        70;

      const postPayload = action.payload.form;

      if (!data) {
        const response = yield call(createPost, postPayload);
        if (response?.status == 0) {
          toast.success(response?.result?.message);
          yield put(createPostSuccess(response?.result?.data));
        } else {
          toast.error(response?.result?.message);
          yield put(createPostFail());
        }
      } else {
        toast.error("Please Don't use Abusive language");
      }
    } else {
      yield put(toxicError());
    }
  } catch (error) {
    toast.error(error);
    yield put(toxicError());
  }
}

function* createPostSaga(action) {
  try {
    const response = yield call(createPost, action.payload);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      yield put(createPostSuccess(response?.result?.data));
    } else {
      toast.error(response?.result?.message);
      yield put(createPostFail());
    }
  } catch (error) {
    toast.error(error);
    yield put(createPostFail());
  }
}

function* removePostSaga(action) {
  try {
    const response = yield call(removePostApi, action.payload);
    if (response?.status == 0) {
      console.log(window.location.hash == "#/community", "removePostSaga");
      toast.success(response?.result?.message);
      if (window.location.hash == "#/community") {
        yield put(removePostSuccess({ id: action.payload.post }));
      } else {
        const encouragementPostListRender = yield select(
          (state) =>
            state.EncouragementgroupsReducer.encouragementPostListRenderData
        );
        const updateEncouragementPostListRenderData = [
          ...encouragementPostListRender,
        ].filter((item) => item._id !== action?.payload?.post);
        yield put(
          encouragementRenderPostListLoad(updateEncouragementPostListRenderData)
        );
      }
    } else {
      toast.error(response?.result?.message);
    }
  } catch (error) {
    toast.error(error);
  }
}

function* toxicSaga(action) {
  try {
    console.log(action, "action");
    const toxicData = {
      apiKey: action.payload.apiKey,
      comment: action.payload.comment,
    };
    const response = yield call(toxicApi, toxicData);
    if (response?.status == 0) {
      const data =
        response.result?.data?.data?.attributeScores?.TOXICITY?.summaryScore
          ?.value *
          100 >
        70;

      const commentPayload = {
        comment: action.payload.comment,
        typeOfComment: action.payload.typeOfComment,
        post: action.payload.post,
        userId: action.payload.userId,
      };

      if (!data) {
        const response = yield call(commentOnPostApi, commentPayload);
        if (response?.status == 0) {
          yield put(postLikeSuccess(response?.result?.data));
          yield put(commentPostSuccess(action?.payload));
        } else {
          toast.error("Please Don't use Abusive language");
          yield put(createPostFail());
        }
      } else {
        toast.error("Please Don't use Abusive language");
      }
    } else {
      yield put(toxicError());
    }
  } catch (error) {
    toast.error(error);
    yield put(toxicError());
  }
}

function* postLikeSaga(action) {
  try {
    console.log(action.payload, "232");
    const response = yield call(commentOnPostApi, action.payload);
    if (response?.status == 0) {
      yield put(postLikeSuccess(response?.result?.data));
      yield put(commentPostSuccess(action?.payload));
    }
  } catch (error) {
    toast.error(error);
    yield put(createPostFail());
  }
}

function* CommunitySaga() {
  yield takeLatest(createPostLoad.type, createPostSaga);
  yield takeLatest(removePostload.type, removePostSaga);
  yield takeLatest(postLikeLoad.type, postLikeSaga);
  yield takeLatest(toxicLoad.type, toxicSaga);
  yield takeLatest(toxicPostLoad.type, toxicPostSaga);
}

export default CommunitySaga;
